<div class="dialog-container dialog-consent">
  <div class="dialog-head">
    <span>Bank Account Linking Consent</span>
    <img 
    src="../../../assets/images/cross_icon_grey.svg" 
    alt="close" 
    (click)="closeModal()" 
    (keydown)="closeModal()" 
    tabindex="0">
    </div>
  <div class="dialog-body">
    <b>Your Privacy & Security Matter</b>
    <br><br>
    By connecting your bank account, you authorize us to securely access your transaction data to provide [e.g., financial insights, budgeting tools]. This includes details like amounts, dates, and merchant names.    <br><br>
    
    <b>What We Do:</b>
    <br><br>
    <ul>
      <li>Analyze your transactions to offer personalized insights and reports.</li>
      <li>Use your data to enhance your experience.</li>
    </ul>
    <br><br>
    
    <b>What We Don’t Do:</b>
    <br><br>
    <ul>
      <li>We never store or share your login credentials.</li>
      <li>We don’t perform transactions or share your data without your consent.</li>
    </ul>
    <br><br>
    
    <b>Security & Compliance:</b>
    <br><br>
    All data is encrypted and processed in accordance with the GDPR and relevant data protection laws. As outlined in your signed <b>Service Agreement</b> and <b>Data Processing Agreement (DPA)</b>, your data is stored and used strictly for agreed purposes.
    <br><br>
    <ul>
      <li><b>Data Retention: </b>Your data is retained only for as long as necessary to provide the agreed services.</li>
      <li><b>Subprocessors: </b>We may use GDPR-compliant subprocessors (e.g., cloud service providers), all bound by strict confidentiality and data protection obligations.</li>
      <li><b>Breach Notification: </b>In the unlikely event of a data breach, you will be informed promptly, in line with GDPR requirements.</li>
    </ul>
    <br><br>
    
    <b>Your Control:</b>
    <br><br>
    You can revoke access to your bank account at any time via your account settings. For full details on how we collect, use, and protect your data, please see our <a class="privacy-link" target="_blank" href="https://www.ace-alternatives.com/privacy-policy.html">Privacy Policy</a> </div>
  <div class="dialog-footer">
    <div class="checkbox">
      <mat-checkbox (change)="checkboxChange($event)"></mat-checkbox>
      <p>I agree that I have read, understood, and consent to the linking of your bank account and transaction data as outlined in this document.</p>
    </div>
    <div class="footer-btn">
      <button class="btn-white" (click)="closeModal()">Cancel</button>
      <button class="btn-green" (click)="submitConsent()" [disabled]="!confirmBankConsent">Continue</button>
    </div>
  </div>
</div>
